import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am a Computer Science student passionate about leveraging data and code to solve real-world problems.
              <br />
              <br />I am fluent in classics like
              <i>
                <b className="purple"> Python, C++, and Java. </b>
              </i>
              <br />
              <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Data Pipelines and Automation Scripts </b>
              </i>
              and also in areas related to{" "}
              <b className="purple">
                Artificial Intelligence and Machine Learning.
              </b>
              <br />
              <br />
              Whenever possible, I apply my passion for developing products with
              <b className="purple"> Flask </b> and Modern Javascript Library and Frameworks like
              <i>
                <b className="purple"> React.js</b>
              </i>
              &nbsp; while visualizing insights using
              <i>
                <b className="purple"> Power BI.</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;